<script lang="ts">
    import {navigate, Route, Router} from "svelte-routing";
    import GalleryPage from "./gallery/GalleryPage.svelte";
    import DetailsPage from "./details/DetailsPage.svelte";
    import MainPage from "./main/MainPage.svelte";
    import InfoPage from "./info/InfoPage.svelte";

    export let url = "";
</script>
<div id="app-grid">
    <header on:click={() => navigate('/')}>
        <div id="titles">
            <img id="logo-upc-header" src="/img/upc.svg" alt="Universitat Politècnica de Catalunya - BarcelonaTECH">
            <h1 class="main-title">Roses UPC</h1>
            <h1 class="main-title">Sant Jordi Digital 2023</h1>
            <img id="rosa-header" src="/img/Rosa-blava-upc.png" alt="Dibuix rosa blava">
        </div>
    </header>


    <main>
        <Router url="{url}">
            <Route path="info" component="{InfoPage}"/>
            <Route path="information" component="{InfoPage}"/>
            <Route path="informacio" component="{InfoPage}"/>
            <Route path="gallery" component="{GalleryPage}"/>
            <Route path="galeria" component="{GalleryPage}"/>
            <Route path="galeriadescripcio">
                <GalleryPage allowDescriptionFilter="true"/>
            </Route>
            <Route path="details/:roseId" let:params>
                <DetailsPage roseId="{params.roseId}"/>
            </Route>
            <Route path="details/:artistType/:roseId" let:params>
                <DetailsPage roseId="{params.roseId}"/>
            </Route>
            <Route path="detalls/:roseId" let:params>
                <DetailsPage roseId="{params.roseId}"/>
            </Route>
            <Route path="detalls/:artistType/:roseId" let:params>
                <DetailsPage roseId="{params.roseId}"/>
            </Route>
            <Route path="/" component="{MainPage}"/>
        </Router>
    </main>

    <footer>
        <div id="footer-content">
            <p class="footer-text">
                Aquest web utilitza <em>cookies</em> pròpies per oferir una experiència i un servei millors. En
                continuar la navegació entenem que acceptes la nostra
                <a class="text-link" href="http://www.upc.edu/avis-legal/politica-de-cookies" target="_blank">política
                    de <i>cookies</i></a>.
            </p>
            <p>La UPC es reserva el dret, en qualsevol moment i sense avís previ, d’eliminar i/o modificar les paraules que contingui la descripció que la Universitat consideri, a parer seu, que no són adequades. Les imatges generades inclouen la referència ‘Rosa UPC 2023’ a la part inferior esquerra. Els usuaris es comprometen a fer un ús adequat de les roses UPC creades i a utilitzar-les sota la seva responsabilitat. La UPC no es fa responsable de les descripcions dels usuaris ni de l'ús indegut que es puguin fer de les imatges generades.</p>
            <p class="footer-text">Roses UPC és un projecte d'UPCArts, amb la col·laboració de l'inLab FIB i el Servei de Comunicació de la UPC.</p>
            <div id="footer-logos">
                <a href="https://www.upc.edu/ca" target="_blank">
                    <img class="footer-logo" src="/img/upc.svg"
                         alt="Universitat Politècnica de Catalunya - BarcelonaTECH">
                </a>
                <a href="https://inlab.fib.upc.edu/" target="_blank">
                    <img class="footer-logo" src="/img/inlab.svg" alt="inLab FIB">
                </a>
                <a href="https://www.upc.edu/ca/upcarts" target="_blank">
                    <img class="footer-logo" src="/img/upcarts.svg" alt="UPCArts">
                </a>
            </div>
        </div>
    </footer>
</div>

<style>

    #app-grid {
        display: grid;
        grid-template-rows: min-content min-content min-content;
        grid-template-columns: 1fr 3fr 1fr;
        grid-template-areas:
                ". header ."
                ". main ."
                "footer footer footer";
        grid-row-gap: 15px;

        background-image: url("../img/Rosa_fons_esquerra(cropped).png"), url("../img/Rosa_fons_dreta.png");
        background-repeat: no-repeat;
        background-position: left bottom, right 35%;
        background-size: min(700px, 70%), min(235px, 25%);
        background-attachment: fixed;
    }

    header {
        grid-area: header;
        /* display: grid;
        grid-template-columns: 1fr 3fr 1fr;
        grid-template-areas: '. titles .'; */
        padding: 1vh 0 2vh 0;
        cursor: pointer;
    }

    #titles {
        grid-area: titles;
        white-space: nowrap;
        position: relative;
    }

    #rosa-header {
        transform: scaleX(90%);
        position: absolute;
        bottom: 0;
        right: 0;
    }

    #rosa-bg-dreta {
        position: absolute;
        right: 0;
        top: 60vh;
        z-index: -1;
    }

    #rosa-bg-esquerra {
        position: absolute;
        left: 0;
        bottom: 0vh;
        z-index: -1;
    }

    #logo-upc-header {
        height: 5vh;
        min-height: 50px;
        margin: 15px 0;
    }

    .main-title {
        color: var(--main-color);
        font-weight: 300;
        font-size: 3.5em;
        margin: 0;
        line-height: 1;
        z-index: 1;
        position: relative;
    }

    main {
        grid-area: main;
    }

    footer {
        grid-area: footer;
        display: grid;
        grid-template-columns: 1fr 3fr 1fr;
        grid-template-areas: '. footer-content .';
        padding: 15px 0;
        margin-top: 15px;
        background-color: rgba(0, 0, 0, 15%);
        text-align: justify;
    }

    #footer-content {
        grid-area: footer-content;
    }

    #footer-logos {
        display: flex;
        flex-direction: row;
        gap: 50px;
    }

    .footer-logo {
        height: 50px;
    }

    @media (max-width: 1290px) {
        #rosa-header {
            top: 0;
        }
    }

    @media (max-width: 1000px) {
        #app-grid, header {
            grid-template-columns: 1fr 6fr 1fr;
        }
    }

    @media (max-width: 800px) {
        #app-grid, header, footer {
            grid-template-columns: 1fr 12fr 1fr;
        }

        .main-title {
            font-size: 8vw;
        }

        #footer-logos {
            flex-direction: column;
            align-items: center;
        }
    }

    @media (max-width: 510px) {
        #app-grid, header, footer {
            grid-template-columns: 1fr 12fr 1fr;
        }
        #rosa-header, #logo-upc-header {
            width: 50%;
        }
        #rosa-header {
            transform: translateY(35%);
        }
    }
</style>